import BarGrid from './barGrid'
export default BarGrid
